import { Controller } from "@api/config";

import {
	TBigWishContentResponse,
	TDefaultTipMenuItemsResponse,
	TGetVerificationTextResponse,
	TIntegrationContentResponse,
	TToysHowToGuideResponse,
} from "./response.types";

class BucketController extends Controller {
	public constructor() {
		super({ requestUrl: "/" });
	}

	/**@GET GET VERIFICATION TEXT */
	public async getVerificationTextAsync() {
		return this.get<TGetVerificationTextResponse>("bucket", "age_verification/text_age_verification.json");
	}

	/** @GET BIGWISH CONTENT */
	public async getBigWishContentAsync() {
		return this.get<TBigWishContentResponse>("bucket", "json/bigWishContent.json");
	}

	/** @GET INTEGRATION CONTENT */
	public async getIntegrationContentAsync() {
		return this.get<TIntegrationContentResponse>("bucket", "json/integration_content.json");
	}

	/**@GET DEFAULT TIP MENU ITEMS */
	public async getDefaultTipMenuItemsAsync() {
		return this.get<TDefaultTipMenuItemsResponse[]>("bucket", "json/default_tip_menu_items.json");
	}

	/**@GET TOYS HOW TO GUIDE */
	public async getToysHowToGuideAsync() {
		return this.get<TToysHowToGuideResponse[]>("bucket", "json/toys_how_to_guide.json");
	}
}

export const bucketAPI = new BucketController();
